import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MedicineMetadata } from '@components/medication-dosage-form/medication-dosage-form.component';
import { map, Observable, tap } from 'rxjs';
import { PatientSubscribeToPSP } from 'src/app/_models/PSP/psp-new-patient-sub.model';
import { AdminPspRocheSubscriptionResponse } from 'src/app/_models/PSP/psp-roche.model';
import { AdminPspSubscriptionRespond } from 'src/app/_models/PSP/Psp-Task-Details.model';
import { PSPTaskResponse } from 'src/app/_models/PSP/psp-task.model';
import { GenericResponse } from 'src/app/_models/response.model';
import { baseUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PspTasksService {
  // baseUrl = 'https://149d40be-2cb3-410b-bf05-75d527e0ad3f.mock.pstmn.iO/';
  url =  'api/AdminPspSubscriptions';
  relationsUrl =  'api/AdminPspRelations/GetPspRelations';
  pspProgramsUrl =  'api/PspPrograms';
  constructor(private http: HttpClient) {}

  getAllTasks(params): Observable<PSPTaskResponse> {
    return this.http.get<PSPTaskResponse>(`${this.url}/GetAdminPspTasks`, {
      params,
    });
  }

  getSubscriptionById(params): Observable<AdminPspSubscriptionRespond> {
    return this.http.get<AdminPspSubscriptionRespond>(`${this.url}/GetById`, {
      params,
    });
  }

  getPspRelations(): Observable<any> {
    return this.http.get<any>(`${this.relationsUrl}`);
  }

  updatePspSubscription(body): Observable<any> {
    return this.http.put(`${this.url}/UpdatePspSubscription`, body);
  }

  addNewPatient(patient: any): Observable<any> {
    return this.http.post(`${this.url}/SubscribeToPsp`, patient);
  }

  getRocheSubscriptionById(params): Observable<AdminPspRocheSubscriptionResponse> {
    return this.http.get<AdminPspRocheSubscriptionResponse>(`${this.url}/GetRochePspSubscriptionById`, {
      params,
    });
  }

  ActivateRochePspSubscription(body): Observable<any> {
    return this.http.put(`${this.url}/ActivateRochePspSubscription`, body);
  }
  
  getProgramMedicationsAsSearchResults(programId: number): Observable<GenericResponse<MedicineMetadata>> {
    return this.http.get<GenericResponse<MedicineMetadata>>(`${this.pspProgramsUrl}/program-medicines`,{params: {programId}})
  }
}
